export const BENEFITS_CATALOG = [
  "MEAL",
  "ACCOMMODATION",
  "TIP_INDIVIDUAL",
  "TIP_POOLED",
  "BONUS_MONTHLY",
  "BONUS_KPI",
  "BONUS_HOLIDAY",
  "INSURANCE_BHYT",
  "INSURANCE_BHXH",
  "PAID_LEAVE",
  "OVERTIME_PAID",
  "TRANSPORT_ALLOWANCE",
  "UNIFORM_PROVIDED",
  "TRAINING_PROVIDED",
  "CAREER_GROWTH",
  "FLEXIBLE_SHIFT",
] as const;

export type Benefit = (typeof BENEFITS_CATALOG)[number];

export const BENEFIT_LABEL_VI: Record<Benefit, string> = {
  MEAL: "Bao ăn",
  ACCOMMODATION: "Bao ở",
  TIP_INDIVIDUAL: "Tip riêng",
  TIP_POOLED: "Tip chia chung",
  BONUS_MONTHLY: "Thưởng hàng tháng",
  BONUS_KPI: "Thưởng KPI",
  BONUS_HOLIDAY: "Thưởng lễ tết",
  INSURANCE_BHYT: "BHYT",
  INSURANCE_BHXH: "BHXH",
  PAID_LEAVE: "Phép có lương",
  OVERTIME_PAID: "OT có lương",
  TRANSPORT_ALLOWANCE: "Hỗ trợ xăng xe",
  UNIFORM_PROVIDED: "Cấp đồng phục",
  TRAINING_PROVIDED: "Đào tạo",
  CAREER_GROWTH: "Cơ hội thăng tiến",
  FLEXIBLE_SHIFT: "Ca linh hoạt",
};
